module.exports = __webpack_public_path__ + "img/team-1.0e461794.jpg";